export enum BeneficiaryRelationshipTypeEnum {
  Spouse = 1,
  Child = 2,
  Mother = 3,
  Father = 4,
  Sibling = 5,
  Grandchild = 6,
  Grandparent = 7,
  Friend = 8,
  Other = 9
}
